import React, { useState, useCallback } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import DynmBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/DynmBtn';
import TextRankItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/TextRankItem';
import TextRankList from '@wconcept/wconcept-ui-renewal/components/organisms/_list/TextRankList';
import {
  clearWckRecentSearchList,
  setWckRecentResultList,
} from '@wconcept/wconcept-common/utils/cookie';
import { PopularKeyword } from '@wconcept/wconcept-common/models/renewal/search';
import * as S from './style';

// 인기 검색어
export type PopularWordsInfo = {
  ranking: number;
  searchWord: string;
  icon: number; // (0 : 변동없음, 1: NEW, 2:순위상승, 3: 순위하락)
  count: number;
};

interface IProps {
  /** isNativeAppBoth */
  isNativeAppBoth: boolean;
  /** recentSrch */
  recentSrch: string[];
  /** popularSrch */
  popularSrch?: PopularKeyword[];
  /** onClick */
  onClick?: (value: string, type: string, no: number) => void;
  /** onClose */
  onClose?: () => void;
  /** onClickDel */
  onClickDel?: (value: string[]) => void;
}

const SchKeywordListDesktop = ({
  isNativeAppBoth,
  recentSrch = [],
  popularSrch,
  onClick,
  onClose,
  onClickDel,
}: IProps) => {
  // ITEM HANDLER : onClickItem
  const onClickItem = useCallback(
    (value: string, type: string, no: number) => {
      if (onClick) {
        onClick(value, type, no);
      }
    },
    [onClick]
  );

  // ITEM HANDLER : onClickDelRcntSrch
  const onClickDelRcntSrch = useCallback(async () => {
    await clearWckRecentSearchList();
    if (onClickDel) {
      onClickDel([]);
    }
  }, [onClickDel]);

  // ITEM HANDLER : onClickDelRcntSrchItem
  const onClickDelRcntSrchItem = useCallback(
    async (value: string) => {
      const nextRecentKeywords = recentSrch.filter(recent => recent !== value);
      await setWckRecentResultList(recentSrch, value);
      if (onClickDel) {
        onClickDel(nextRecentKeywords);
      }
    },
    [onClickDel, recentSrch]
  );

  //= ================== ITEM RENDERER ======================

  // ITEM RENDERER : getRecentSrchListRender
  const getRecentSrchListRender = useCallback(() => {
    if (recentSrch.length > 0) {
      return (
        <div>
          {recentSrch.map((v, i) => (
            <DynmBtn
              key={v}
              mode="word"
              text={v}
              onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                e.preventDefault();
                onClickItem(v, 'recent', i + 1);
              }}
              onClose={() => {
                onClickDelRcntSrchItem(v);
              }}
            />
          ))}
        </div>
      );
    }
    return <Text className="is-empty">최근 검색어가 없습니다.</Text>;
  }, [onClickDelRcntSrchItem, onClickItem, recentSrch]);

  // ITEM RENDERER : getPopularSrchRender
  const getPopularSrchRender = useCallback(
    () => (
      <TextRankList
        items={
          popularSrch &&
          popularSrch.map((v, i) => (
            <TextRankItem
              key={v.searchWord}
              text={v.searchWord}
              rank={v.ranking}
              isNew={v.icon === 1}
              onClick={() => {
                // sendTagSearchInitPageOnClickRankingItem(
                //   true,
                //   isNativeAppBoth,
                //   genderType.toLowerCase(),
                //   v
                // );
                onClickItem(v.searchWord, 'popular', i + 1);
              }}
            />
          ))
        }
      />
    ),
    [onClickItem, popularSrch]
  );

  return (
    <S.SchKeywordListDesktop className="sch-keywordlist-desktop">
      <div className="recent">
        <Title
          level={3}
          suffix={
            recentSrch.length > 0 && (
              <Button onClick={onClickDelRcntSrch}>
                <Text color="#999" size={13} weight={400} lineHeight="120%">
                  전체삭제
                </Text>
              </Button>
            )
          }
        >
          최근 검색어
        </Title>
        {getRecentSrchListRender()}
      </div>
      <div className="popular">
        <Title level={3}>인기 검색어</Title>
        {getPopularSrchRender()}
      </div>
      <div className="bottom">
        <Button onClick={onClose}>닫기</Button>
      </div>
    </S.SchKeywordListDesktop>
  );
};

export default SchKeywordListDesktop;
